import {ReactComponent as LockIcon} from '../../assets/icons/lock.svg'
import {HelpText} from "../HelpText";

export const NotAuthorizedPage = () => {
    return <div className="container py-8 text-center not-found-page">
        <LockIcon />
        <h1 className="big-living-typo my-4">Access Denied</h1>
        <p className="mb-8">You are not authorized to access this page.</p>
        <HelpText/>
    </div>
}
